import * as authActions from './auth.actions';
import { createSelector } from 'reselect';

export interface IAuthState {
  token: string;
}

export const initialState: IAuthState = {
  token: null
};

export function reducer(state = initialState, action: authActions.Actions): IAuthState {
  switch (action.type) {
    case authActions.LOGIN:
      return state;

    case authActions.LOGIN_SUCCESS:
      const token = action.payload;
      return {
        token
      };

    case authActions.LOGOUT:
      return {
        token: null
      };

    default: {
      return state;
    }
  }
}

export const getToken = state => state.token;
export const getAuthSelector = state => state.auth;
export const getAuthTokenSelector = createSelector(getAuthSelector, getToken);
